// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"7c572b4d","554":"3b1a0bc2","633":"8fc16c6f","637":"85dc128d","796":"5acd3eb5","915":"bfad86be"}[chunkId] + ".css";
};